<div
  class="loading-overlay"
  *ngIf="loading.loading$ | async"
  role="status"
  aria-live="polite"
  aria-busy="true">

  <div class="loading-card">
    <div class="loading-spinner" aria-hidden="true"></div>

    <div class="loading-content">
      <span class="loading-title">Loading</span>
      <span class="loading-subtitle">Please wait while we prepare everything...</span>
    </div>
  </div>

</div>